import React, { FC, ReactNode } from 'react';
import { Link as LinkReactRouter } from 'react-router';

import { Theme, Typography } from '@mui/material';
import { TypographyProps } from '@mui/material/Typography/Typography';

import useStyles from './styles.module';

interface Props extends TypographyProps {
  isNewTab?: boolean;
  pathname: string;
  children: ReactNode;
  onClick?: () => void;
  activeColor?: TypographyProps['color'] | ((theme: Theme) => string);
  isActive?: boolean;
  icon?: ReactNode;
}

const Link: FC<Props> = ({
  isNewTab,
  pathname,
  children,
  color,
  activeColor,
  isActive,
  display,
  alignItems,
  onClick,
  icon,
  ...props
}) => {
  const { classes } = useStyles();

  return (
    <>
      {isNewTab ? (
        <a
          href={pathname}
          target="_blank"
          className={classes.link}
          rel="noreferrer"
        >
          <Typography
            color={isActive ? activeColor : color}
            {...props}
            alignItems={alignItems || 'center'}
            display={display || 'flex'}
          >
            {children}
          </Typography>
          {icon}
        </a>
      ) : (
        <LinkReactRouter
          to={{ pathname }}
          className={classes.link}
          onClick={onClick}
        >
          <Typography
            color={isActive ? activeColor : color}
            {...props}
            alignItems={alignItems || 'center'}
            display={display || 'flex'}
          >
            {children}
          </Typography>
          {icon}
        </LinkReactRouter>
      )}
    </>
  );
};

export default Link;
